import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    components: {
      selectValue: 'Select value',
      actionlist: {
        'no-items-available': 'No items available',
      },
      itemsPerPage: 'Items per Page',
      page: 'Page',
      number: '{{number}}',
      outOfLabel: 'out of',
    },
  },
};

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  debug: false,
  lng: 'en',
  defaultNS: 'components',
  ns: ['components'],
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

export { i18n };
